import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "OpinionService",
  controller: "OpinionAnalysis",
};

const methods = [
  "GetBigDataHotWords",
  "GetMediaTop10",
  "GetTopTenTopics",
  "GetOpinionEmotion",
  "GetEmotionTrendByMonth",
  "GetEmotionTrend",
  "GetTodayReport",
  "GetAnalysises"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function(data) {
      return this.post(path, data);
    };
  });
};

const OpinionResourcesApi = ZJApi.defineNewApi("OpinionResourcesApi", factory);

export default OpinionResourcesApi;
